import { AepsType } from './aeps.type';



const INITIAL_STATE = {


    //aeps Transfer
    transferTotalAmount3: '',
    surcharge3: '',
    createdOrderResponse3: '',
    orderId3: '',
    aepsMobile: '',

    //aeps biometry

    aepsBiometricDta: '',
    aepsBiometricDtaCaptureStatus: '',

    //aeps amount
    aepsAmount: '',
    aepsResponse: '',
    aepsReq: '',
    aepsSelectedBank: '',
    aepsFullName: '',
    aepsAadhaar: '',
    aepsMobile: '',
    aepsCurTime: '',

    //aeps default page
    aepsSection: 'txnHistory',
    checkingDriverStatus: '',
    captureUrl: '',
    deviceInfoUrl: '',


    formDate: '',
    toDate: '',

    readyDeviceName: '',

    //cash withdrawl request
    aepsCashWithDrawllReq: '',
    aepsReqBeforeBalanceEnuiry: '',

    payTmKycSection: '',

    aepsMerchant: '',
    merchantAuthId: '',
    merchantAuthIdPayTM: ''




};

const aepsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {


        case AepsType.setMoneyTransferTotalAmount3:
            return {
                ...state,
                transferTotalAmount3: action.payload,
            };

        case AepsType.setMoneyTransferSurChargeAmount3:
            return {
                ...state,
                surcharge3: action.payload,
            };

        case AepsType.showCreateOrderResponse3:
            return {
                ...state,
                createdOrderResponse3: action.payload,
            };

        case AepsType.setOrderId3:
            return {
                ...state,
                orderId3: action.payload,
            };
        case AepsType.setAepsMobile:
            return {
                ...state,
                aepsMobile: action.payload,
            };



        //biometric

        case AepsType.setBiometricDta:
            return {
                ...state,
                aepsBiometricDta: action.payload,
            };
        case AepsType.setBiometricDtaCaptureStatus:
            return {
                ...state,
                aepsBiometricDtaCaptureStatus: action.payload,
            };

        //aeps pricing
        case AepsType.setAepsAmount:
            return {
                ...state,
                aepsAmount: action.payload,
            };

        //aeps default section
        case AepsType.setAepsSection:
            return {
                ...state,
                aepsSection: action.payload,
            };
        case AepsType.checkingDriverStatus:
            return {
                ...state,
                checkingDriverStatus: action.payload,
            };
        case AepsType.setCaptureUrl:
            return {
                ...state,
                captureUrl: action.payload,
            };
        case AepsType.setDeviceInfoUrl:
            return {
                ...state,
                deviceInfoUrl: action.payload,
            };
        case AepsType.setAepsResponse:
            return {
                ...state,
                aepsResponse: action.payload,
            };
        case AepsType.setAepsRequest:
            return {
                ...state,
                aepsReq: action.payload,
            };
        case AepsType.storeAepsReqBeforeBalanceEnuiry:
            return {
                ...state,
                aepsReqBeforeBalanceEnuiry: action.payload,
            };


        case AepsType.setSelectedBankName:
            return {
                ...state,
                aepsSelectedBank: action.payload,
            };

        case AepsType.setFullName:
            return {
                ...state,
                aepsFullName: action.payload,
            };

        case AepsType.setAadhaar:
            return {
                ...state,
                aepsAadhaar: action.payload,
            };

        case AepsType.setMobile:
            return {
                ...state,
                aepsMobile: action.payload,
            };

        case AepsType.setCurrentTimeStamp:
            return {
                ...state,
                aepsCurTime: action.payload,
            };

        case AepsType.setFilterEndDate:
            return {
                ...state,
                toDate: action.payload,
            };
        case AepsType.setFilterStartDate:
            return {
                ...state,
                formDate: action.payload,
            };
        case AepsType.setReadyDeviceName:
            return {
                ...state,
                readyDeviceName: action.payload,
            };
        case AepsType.setAepsCashWithDrwalReq:
            return {
                ...state,
                aepsCashWithDrawllReq: action.payload,
            };


        case AepsType.setAmount3:
            return {
                ...state,
                amount3: action.payload,
            };
        case AepsType.setStatusEnqResponse3:
            return {
                ...state,
                createOrderStatusResponse3: action.payload,
            };

        case AepsType.setCreteOrderReq3:
            return {
                ...state,
                createOrderReq3: action.payload,
            };

        case AepsType.setCreateOrderRes3:
            return {
                ...state,
                createOrderRes3: action.payload,
            };

        case AepsType.setMoneyTransferProgress:
            return {
                ...state,
                moneyTransferProgress: action.payload,
            };

        case AepsType.setFilterEndDate:
            return {
                ...state,
                toDate: action.payload,
            };
        case AepsType.setFilterStartDate:
            return {
                ...state,
                formDate: action.payload,
            };

        case AepsType.setPayTMAepsSection:
            return {
                ...state,
                payTmKycSection: action.payload,
            };
        case AepsType.storeAepsMerchantInfo:
            return {
                ...state,
                aepsMerchant: action.payload,
            };

        case AepsType.setMerchantAuthId:
            return {
                ...state,
                merchantAuthId: action.payload,
            };
        case AepsType.setMerchantAuthIdPayTM:
            return {
                ...state,
                merchantAuthIdPayTM: action.payload,
            };
        case AepsType.RESET:
            return INITIAL_STATE;

        default:
            return state;
    }

};

export default aepsReducer; 